export interface ICassa {
  id?: string,
  codice: string,
  descrizione: boolean
  tipoCassa: TipoCassa
}

export enum TipoCassa {
  Nessuno,
  Cassaforte,
  CassaAutomatica,
  FondoStazione
}